import React from "react";
import { Button } from "../controls";
import { useNavigate } from "react-router-dom";

const NotFound = ({ msg = "Data not found" }) => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col gap-5 items-center justify-center px-4">
      <span className="text-gray-500 font-medium text-[24px]">{msg}</span>
      <Button
        onClick={() => navigate(-1)}
        variant="contained"
        color="primary"
        className="mt-6 px-6 py-3 text-lg capitalize rounded-lg shadow-md"
      >
        Go Back
      </Button>
    </div>
  );
};

export default NotFound;
